import React, { useState } from "react";
import styles from "./LockOverlay.module.css";

/**
 * LockOverlay — shows a lock icon over blurred/locked content.
 * Does NOT change children's layout. Just adds blur + lock overlay on top.
 *
 * @param {React.ReactNode} children - The content to render (will be blurred)
 * @param {boolean} locked - Whether to show the lock overlay
 * @param {string} [message] - Custom message on click
 * @param {object} [style] - Extra styles for the wrapper
 * @param {string} [className] - Extra class for the wrapper
 */
const LockOverlay = ({ children, locked, message, style, className, iconTop, id }) => {
  const [showToast, setShowToast] = useState(false);

  if (!locked) return id ? <div id={id}>{children}</div> : children;

  const handleLockClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2500);
  };

  return (
    <div id={id} className={`${styles.lockWrapper} ${className || ""}`} style={style}>
      {/* Children render normally but blurred */}
      <div className={styles.blurredContent}>
        {children}
      </div>

      {/* Lock icon always centered */}
      <div className={styles.lockIcon} style={{ top: iconTop || "50%" }} onClick={handleLockClick}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="11" width="18" height="11" rx="2" fill="#6524EB" />
          <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="#6524EB" strokeWidth="2" strokeLinecap="round" />
          <circle cx="12" cy="16" r="1.5" fill="#fff" />
          <rect x="11.25" y="16.5" width="1.5" height="2.5" rx="0.75" fill="#fff" />
        </svg>
      </div>

      {/* Toast message */}
      {showToast && (
        <div className={styles.toast} onClick={(e) => e.stopPropagation()}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
            <rect x="3" y="11" width="18" height="11" rx="2" fill="#6524EB" />
            <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="#6524EB" strokeWidth="2" strokeLinecap="round" />
            <circle cx="12" cy="16" r="1.5" fill="#fff" />
          </svg>
          <span>{message || "You are not authorized. Contact your admin to get access."}</span>
        </div>
      )}
    </div>
  );
};

export default LockOverlay;
